import moment from "moment";

export function formatDateUTC(dateStr, format = "DD/MM/YYYY") {
  if (!dateStr) return "";
  return moment.utc(dateStr).format(format);
}

export function calcAgeFromUTC(dateStr) {
  if (!dateStr) return "";
  const birth = moment.utc(dateStr);
  return moment.utc().diff(birth, "years");
}
